/* Copyright 2019 VMware, Inc. All rights reserved. -- VMware Confidential */

module platform {

   import IInjectorService = angular.auto.IInjectorService;
   import ManagedObjectReference = com.vmware.vim.binding.vmodl.ManagedObjectReference;

   /**
    * Wrapper over downgraded service \vim-clients\applications\h5\ng-next-app\src\app\platform\services\cis-id-converter\cis-id-converter.service.ts
    */
   export class CisIdConverterWrapper {
      static $inject = ["$injector"];
      private _vcCisIdConverter: any;

      constructor(private $injector: IInjectorService) {
      }

      get vcCisIdConverter(): any {
         if (!this._vcCisIdConverter) {
            this._vcCisIdConverter = this.$injector.get("vcCisIdConverter");
         }
         return this._vcCisIdConverter;
      }

      public toGlobalCisId(moRef?: ManagedObjectReference|null, serverGuid?: string): string {
         return this.vcCisIdConverter.toGlobalCisId(moRef, serverGuid);
      }

      public fromGlobalCisId(cisId?: string, moType?: string, serverGuid?: string) {
         return this.vcCisIdConverter.fromGlobalCisId(cisId, moType, serverGuid);
      }

      public toFullCisId(cisId: string, objectType?: string, serverGuid?: string) {
         return this.vcCisIdConverter.toFullCisId(cisId, objectType, serverGuid);
      }

      public getValue(cisId: string): string | undefined {
         return this.vcCisIdConverter.getValue(cisId);
      }

      public getType(cisId: string): string | undefined {
         return this.vcCisIdConverter.getType(cisId);
      }

      public getServerGuid(cisId: string): string | undefined {
         return this.vcCisIdConverter.getServerGuid(cisId);
      }
   }

   angular.module("com.vmware.platform.ui").service("cisIdConverter", CisIdConverterWrapper);
}
